import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'
import { es } from '@braid/vue-formulate-i18n'

//registro nuevos inputs
import InputPrice from '../components/forms/InputPrice'
Vue.component('InputPrice', InputPrice)
import InputAutocomplete from '../components/forms/InputAutocomplete'
Vue.component('InputAutocomplete', InputAutocomplete)
import InputFile from '../components/forms/InputFile'
Vue.component('InputFile', InputFile)
import InputTags from '../components/forms/InputTags'
Vue.component('InputTags', InputTags)
import InputDate from '../components/forms/InputDate'
Vue.component('InputDate', InputDate)
import InputDamageType from '../components/forms/InputDamageType'
Vue.component('InputDamageType', InputDamageType)
import InputIdentification from '../components/forms/InputIdentification'
Vue.component('InputIdentification', InputIdentification)
import Phone from '../components/forms/InputPhone'
Vue.component('Phone', Phone)
import InputSelect from '../components/forms/InputSelect'
Vue.component('InputSelect', InputSelect)

import {customRules } from '../components/forms/customRules'

Vue.use(VueFormulate, {
  plugins: [ es ], 
  locale: 'es',
  library: {
    autocomplete: { classification: 'text', component: 'InputAutocomplete' },
    price: { classification: 'text',  component: 'InputPrice' },
    file: { classification: 'text',  component: 'InputFile' },
    tags: { classification: 'text',  component: 'InputTags' },
    date: { classification: 'date',  component: 'InputDate' },
    damageType: { classification: 'text',  component: 'InputDamageType' },
    identification: { classification: 'text',  component: 'InputIdentification' },
    phone: { classification: 'phone',  component: 'Phone' },
    selectSearch: { classification: 'text',  component: 'InputSelect' },
  },
  rules:{
		...customRules
	},
})
import '@braid/vue-formulate/themes/snow/snow.scss';